import { ChangeCircle } from '@mui/icons-material';
import { Users, FileText, Wallet, Home, Video, User, BookOpen, Tag, UserPlus, Database, BarChart, Edit, Landmark, Bug, Award, Newspaper, Settings, MessageCircle, DollarSign } from "lucide-react";

export const SuperadminRouteName = [
    {
        title: "Dashboard",
        links: [
            { label: "Overview", path: "/", icon: <Home style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Management",
        links: [
            { label: "Admins", path: "/management/admins", icon: <Users style={{ height: '16px', width: '16px' }} /> },
            { label: "Registration Numbers", path: "/management/registration-numbers", icon: <Database style={{ height: '16px', width: '16px' }} /> },
            { label: "Partners", path: "/management/partners", icon: <Users style={{ height: '16px', width: '16px' }} /> },
            { label: "Affiliates", path: "/management/affiliates", icon: <Users style={{ height: '16px', width: '16px' }} /> },
            { label: "Customers", path: "/management/customers", icon: <User style={{ height: '16px', width: '16px' }} /> },
            // { label: "Wallet Report", path: "/management/admin-wallet-report", icon: <Wallet style={{ height: '16px', width: '16px' }} /> },
            { label: "Discount Coupons", path: "/management/discount-coupons", icon: <Tag style={{ height: '16px', width: '16px' }} /> },
            { label: "Partner Bank Details", path: "/management/partner-bank-details", icon: <Landmark style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Revenue",
        links: [
            { label: "Revenue Distribution", path: "/revenue/distribution", icon: <DollarSign style={{ height: '16px', width: '16px' }} /> },
            { label: "Revenue Settings", path: "/revenue/settings", icon: <Settings style={{ height: '16px', width: '16px' }} /> },
            { label: "Payouts", path: "/revenue/payouts", icon: <Wallet style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Content",
        links: [
            { label: "Report Editor", path: "/content/report-editor", icon: <Edit style={{ height: '16px', width: '16px' }} /> },
            { label: "Generated Report", path: "/content/generated-report", icon: <FileText style={{ height: '16px', width: '16px' }} /> },
            { label: "Blogs", path: "/content/blogs", icon: <BookOpen style={{ height: '16px', width: '16px' }} /> },
            { label: "Tutorial Videos", path: "/content/tutorial-videos", icon: <Video style={{ height: '16px', width: '16px' }} /> },
            { label: "Business Videos", path: "/content/business-videos", icon: <Video style={{ height: '16px', width: '16px' }} /> },
            { label: "Testimonial Videos", path: "/content/testimonial-videos", icon: <MessageCircle style={{ height: '16px', width: '16px' }} /> },
            { label: "Awards & Rewards", path: "/content/awards", icon: <Award style={{ height: '16px', width: '16px' }} /> },
            { label: "Media Coverage", path: "/content/media-coverage", icon: <Newspaper style={{ height: '16px', width: '16px' }} /> },
            { label: "Site Settings", path: "/content/site-settings", icon: <Settings style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Bug Tracker",
        links: [
            { label: "Dashboard", path: "/bug-tracker/dashboard", icon: <BarChart style={{ height: '16px', width: '16px' }} /> },
            { label: "All Issues", path: "/bug-tracker/issues", icon: <Bug style={{ height: '16px', width: '16px' }} /> },
            { label: "Report Bug", path: "/bug-tracker/report", icon: <Edit style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Settings",
        links: [
            { label: "Change Password", path: "/settings/change-password", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
            { label: "Terms of Use", path: "/settings/terms-of-use", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
            { label: "Privacy Policy", path: "/settings/privacy-policy", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
            { label: "Refund Policy", path: "/settings/refund-policy", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
            { label: "Shipping Policy", path: "/settings/shipping-policy", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
        ],
    },
];

export const AdminRouteName = [
    {
        title: "Dashboard",
        links: [
            { label: "Overview", path: "/", icon: <Home style={{ height: '16px', width: '16px' }} /> },
            { label: "My Profile", path: "/dashboard/my-profile", icon: <UserPlus style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Management",
        links: [
            { label: "Partners", path: "/management/partners", icon: <Users style={{ height: '16px', width: '16px' }} /> },
            { label: "Customers", path: "/management/customers", icon: <User style={{ height: '16px', width: '16px' }} /> },
            // { label: "Wallet Report", path: "/management/partner-wallet-report", icon: <Wallet style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Settings",
        links: [
            { label: "Change Password", path: "/settings/change-password", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
        ],
    },
];

export const PartnerRouteName = [
    {
        title: "Dashboard",
        links: [
            { label: "Overview", path: "/", icon: <Home style={{ height: '16px', width: '16px' }} /> },
            { label: "My Profile", path: "/dashboard/my-profile", icon: <UserPlus style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Management",
        links: [
            { label: "Affiliates", path: "/management/affiliates", icon: <Users style={{ height: '16px', width: '16px' }} /> },
            { label: "Customers", path: "/management/customers", icon: <User style={{ height: '16px', width: '16px' }} /> },
            // { label: "Wallet Report", path: "/management/customer-wallet-report", icon: <Wallet style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Settings",
        links: [
            { label: "Change Password", path: "/settings/change-password", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
        ],
    },
];

export const AffiliateRouteName = [
    {
        title: "Dashboard",
        links: [
            { label: "Overview", path: "/", icon: <Home style={{ height: '16px', width: '16px' }} /> },
            { label: "My Profile", path: "/dashboard/my-profile", icon: <UserPlus style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Management",
        links: [
            { label: "Customers", path: "/management/customers", icon: <User style={{ height: '16px', width: '16px' }} /> },
        ],
    },
    {
        title: "Settings",
        links: [
            { label: "Change Password", path: "/settings/change-password", icon: <ChangeCircle style={{ height: '16px', width: '16px' }} /> },
        ],
    },
];